import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {YzTreePickerComponent} from "./yz-tree-picker.component";

@Injectable({
  providedIn: 'root'
})
export class YzTreePickerService {

  constructor(public dialog: MatDialog) {
  }

  /**
   * 打开选择器
   * @param option
   */
  openTreePicker(option: { tree: Array<listOption>, titleName?: string, value?: string, closeBtnText?: string, pickerClassName?: string, onOk?: (value: any) => void }) {
    const dialogRef = this.dialog.open(YzTreePickerComponent, {
      panelClass: 'tree-picker-panel',
      backdropClass: 'tree-picker-panel-bg',
      autoFocus: false, // 对话框应集中在打开的地方,使搜索框不聚焦
      closeOnNavigation: true, // 当用户在浏览器历史记录中向后或向前导航时，对话框是否应关闭。
      hasBackdrop: true,
      data: {
        titleName: option.titleName == undefined ? null : option.titleName, // 选择器标题
        value: option.value == undefined ? null : option.value, // 选择器回显值
        tree: option.tree, // 数据源
        closeBtnText: option.closeBtnText == undefined ? null : option.closeBtnText, // 关闭按钮文本
        pickerClassName: option.pickerClassName == undefined ? null : option.pickerClassName // 面板自定义class
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (option.onOk) {
        option.onOk(result ? result : []);
      }
    });
  }
}

export class listOption {
  title: string;
  value: string;
  children?: listOption
}

// 组件参数
export class treePickerParams {
  tree: Array<listOption> = []; // 数据源
  titleName?: string = null; // 选择器标题
  value?: string = null; // 选择器回显值
  closeBtnText?: string = null; // 关闭按钮文本
  pickerClassName?: string = null; // 面板自定义class
}
